import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const pendingJourneysEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-journeys", jiraSpaEntry: "async-servicedesk-journeys" */ './src/ui/PendingJourneysPage'
			),
	),
	getPreloadProps: () => ({
		queries: {},
		entryPoints: {},
		extraProps: {},
	}),
});
